module.exports = __webpack_public_path__ + "img/notifications.e06a30eb.png";